/* eslint-disable max-lines */
import createApiAction from '../../api/createApiAction';
import { I18n } from '../../utils/i18n';
import toastr from '../../utils/toastr';
import * as c from './types';

export const getMachines = (params) =>
  createApiAction({
    method: 'getMachines',
    params,
    requestAction: c.GET_MACHINES_REQUEST,
    successAction: c.GET_MACHINES_SUCCESS,
    errorHandler(dispatch, { response }) {
      const { error, message } = response.data;
      toastr.error(I18n.t('system_popup'), error ?? message);
      dispatch({
        type: c.GET_MACHINES_ERROR,
        payload: error ?? message
      });
    },
    transformResponse: ({ data }) => data
  });

export const highlightStop = (value) => async (dispatch) => {
  dispatch({
    type: c.HIGHLIGHT_STOP,
    payload: value
  });
};

export const getMachinesGroup = (params) =>
  createApiAction({
    method: 'getMachinesGroup',
    params,
    requestAction: c.GET_MACHINES_GROUP_REQUEST,
    successAction: c.GET_MACHINES_GROUP_SUCCESS,
    errorHandler(dispatch, { response }) {
      const { error } = response.data;
      toastr.error(I18n.t('system_popup'), error);
      dispatch({
        type: c.GET_MACHINES_GROUP_ERROR,
        payload: error
      });
    },
    transformResponse: ({ data }) => data
  });

export const createMachinesGroup = (data) => {
  return createApiAction({
    method: 'createMachinesGroup',
    requestAction: c.CREATE_MACHINES_GROUP_REQUEST,
    successAction: c.CREATE_MACHINES_GROUP_SUCCESS,
    params: { ...data },
    errorHandler(dispatch, { response }) {
      const error = response?.data?.data?.error ?? response;
      toastr.error(I18n.t('system_popup'), error.message);
      dispatch({ type: c.CREATE_MACHINES_GROUP_ERROR, payload: error });
    },
    transformResponse: (response) => response
  });
};

export const deleteMachinesGroup = (data) => {
  return createApiAction({
    method: 'deleteMachinesGroup',
    requestAction: c.DELETE_MACHINES_GROUP_REQUEST,
    successAction: c.DELETE_MACHINES_GROUP_SUCCESS,
    params: { ...data },
    errorHandler(dispatch, { response }) {
      const error = response?.data?.data?.error ?? response;
      toastr.error(I18n.t('system_popup'), error.message);
      dispatch({ type: c.DELETE_MACHINES_GROUP_ERROR, payload: error });
    },
    transformResponse: (response) => response
  });
};

export const updateMachinesGroup = (data) => {
  return createApiAction({
    method: 'updateMachinesGroup',
    requestAction: c.UPDATE_MACHINES_GROUP_REQUEST,
    successAction: c.UPDATE_MACHINES_GROUP_SUCCESS,
    params: { ...data },
    errorHandler(dispatch, { response }) {
      const error = response?.data?.data?.error ?? response;
      toastr.error(I18n.t('system_popup'), error.message);
      dispatch({ type: c.UPDATE_MACHINES_GROUP_ERROR, payload: error });
    },
    transformResponse: (response) => response
  });
};

export const getAssignedMachinesGroupForUser = (params) =>
  createApiAction({
    method: 'getAssignedMachinesGroupForUser',
    params,
    requestAction: c.GET_ASSIGNED_MACHINES_GROUP_FOR_USER_REQUEST,
    successAction: c.GET_ASSIGNED_MACHINES_GROUP_FOR_USER_SUCCESS,
    errorHandler(dispatch, { response }) {
      const { error } = response.data;
      toastr.error(I18n.t('system_popup'), error);
      dispatch({
        type: c.GET_ASSIGNED_MACHINES_GROUP_FOR_USER_ERROR,
        payload: error
      });
    },
    transformResponse: ({ data }) => ({ userId: params, data })
  });

export const addMachinesGroupToUser = (data) => {
  return createApiAction({
    method: 'addMachinesGroupToUser',
    requestAction: c.ADD_MACHINES_GROUP_TO_USER_REQUEST,
    successAction: c.ADD_MACHINES_GROUP_TO_USER_SUCCESS,
    params: { ...data },
    errorHandler(dispatch, { response }) {
      const error = response?.data?.data?.error ?? response;
      toastr.error(I18n.t('system_popup'), error.message);
      dispatch({ type: c.ADD_MACHINES_GROUP_TO_USER_ERROR, payload: error });
    },
    transformResponse: (response) => response
  });
};
